import { LanguageMap } from '../../../types/UITypes';

const LANGUAGE_ID_MAP: LanguageMap = {
  nl: 31,
  en: -1,
  fr: -2,
  de: -3,
};

export { LANGUAGE_ID_MAP };
